export const emphasizeMatchedText = (whole: string, query: string) => {
  const words = query.split(/\s+/).filter((word) => !word.startsWith("-"));
  const regexp = new RegExp(words.join("|"), "ig");
  return whole.replace(regexp, `<em class="searchHighlight">$&</em>`);
};
